import Header from './components/Header';
import Hero from './components/Hero';
import SectionsA from './components/SectionsA';
import SectionsB from './components/SectionsB';
import SectionsC from './components/SectionsC';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <SectionsA />
        <SectionsB />
        <SectionsC />
      </main>
      <Footer />
    </div>
  );
}